<template>
  <div class="main-page-wrapper p0 overflow-hidden">
    <div class="error-page d-lg-flex align-items-center">
      <div class="text-wrapper order-lg-first">
        <div class="logo"><router-link to="/">
          <img src="../assets/images/logo/marshallprint-logo.svg" alt=""></router-link>
        </div>
        <h1 class="font-gordita">Sorry, <br>The Page Can’t <br>be Found.</h1>
        <router-link to="/" class="back-home font-rubik d-flex align-items-center justify-content-center">
          <span>Back to Home</span>
        </router-link>
      </div> <!-- /.text-wrapper -->
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>
